export default "__VITE_ASSET__CwW9bW5Y__"